import { authApiCall } from '../auth/saga';

/**
 * URLs confirmed against mobile's working referrals/api.js — web's
 * originals (`/users/referred-businesses/` and `/users/referred-customers/`)
 * were guesses and both 404'd. Real backend routes use the
 * "<entity>-referrals" word order, not "referred-<entity>".
 */
export const getReferredBusinesses = params =>
  authApiCall({
    url: '/users/business-referrals/',
    method: 'get',
    params,
  });

export const getReferredCustomers = params =>
  authApiCall({
    url: '/users/customer-referrals/',
    method: 'get',
    params,
  });